/**
 * «The answer can take a few minutes» under a question about the whole base that
 * has waited `AFTER_MS` (spec §8.0.1). The answer goes through a queue there,
 * and a «thinking…» marker alone for a minute reads as a hang. «A few
 * minutes», not «a minute»: the wait runs to the server's ten-minute
 * settlement, and a promise the wait outlives reads as a hang too
 * (code-review, #1312).
 *
 * Counted from the turn's `createdAt`, not from mount: a panel reopened on a
 * question asked a minute ago shows the hint at once.
 */

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const AFTER_MS = 10_000;

export function LongWaitHint({ since }: { since: string }) {
  const { t } = useTranslation('assistant');
  const startedAt = Date.parse(since);
  const [shown, setShown] = useState(
    () => Number.isNaN(startedAt) || Date.now() - startedAt >= AFTER_MS
  );

  useEffect(() => {
    if (shown) return;
    const timer = setTimeout(
      () => setShown(true),
      Math.max(0, startedAt + AFTER_MS - Date.now())
    );
    return () => clearTimeout(timer);
  }, [shown, startedAt]);

  if (!shown) return null;
  return (
    <p className="text-xs text-fg-subtle" data-testid="assistant-long-wait">
      {t('status.longWaitOrg')}
    </p>
  );
}
